import { render, staticRenderFns } from "./warningOctagonIcon.vue?vue&type=template&id=1af171a9&"
import script from "./warningOctagonIcon.vue?vue&type=script&lang=js&"
export * from "./warningOctagonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports